import type { Language } from '~/utilities/graphql/codegen';

/**
 * Localized name of `language` (e.g. "English") among the supported languages of `country`, matched
 * on the language part of the isocode (`en_NL` → `en`). Empty when unknown.
 */
export const getLanguageName = (
  supportedLanguages: Record<string, (Language | null | undefined)[]> | undefined,
  country: string,
  language: string | undefined
): string => {
  const languageCode = language?.toLowerCase().split('_')[0];

  if (!languageCode) {
    return '';
  }

  return (
    supportedLanguages?.[country]?.find(
      lang => lang?.isocode?.toLowerCase().split('_')[0] === languageCode
    )?.name || ''
  );
};
